import { Box, Button, Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { useCopyToClipboard } from "@shared/hooks/useCopyToClipboard/useCopyToClipboard";
import { l } from "@shared/locales/i18n";

import * as styles from "./BackupCode.styles";

interface Props {
  backupCode: string;
  copyButtonTextOverride?: string;
  isLoading?: boolean;
}

const BackupCode = ({ backupCode, copyButtonTextOverride, isLoading }: Props) => {
  const { t } = useTranslation();
  const copyToClipboard = useCopyToClipboard();

  const copyBackupCode = async () => {
    await copyToClipboard(backupCode, { successMessage: t(l.auth.backupCodeCopied) });
  };

  return (
    <div css={styles.backupCodeWrapper}>
      <Box customCss={styles.backupCode} padding="xsmall">
        <Typography as="p" variant="h3" data-testid="backup-code" isLoading={isLoading}>
          {backupCode}
        </Typography>
      </Box>
      <Button
        variant="secondary"
        intention="neutral"
        size="small"
        onClick={copyBackupCode}
        isLoading={isLoading}
      >
        {copyButtonTextOverride || t(l.auth.copyCode)}
      </Button>
    </div>
  );
};

export { BackupCode };
